// extracted by mini-css-extract-plugin
module.exports = {"container":"ServiceAct_container__eOgQB","content":"ServiceAct_content__3J7Go"};